import React, { useState } from 'react';
import Chip from '@material-ui/core/Chip';
import { v1 as uuidV1 } from 'uuid';
import DefaultTooltip from 'components/Utils/DefaultTooltip';

const DISABLED_BACKGROUND = '#d3d3d3';

interface DefaultChipProps {
  onClick?: (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  element?: React.ReactElement;
  text?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  textColor?: string;
  backgroundColor?: string;
  avatar?: React.ReactElement;
  alt?: string;
  onDelete?: () => void;
}

const DefaultChip: React.FC<DefaultChipProps> = ({
  onClick,
  element,
  text,
  className = '',
  disabled = false,
  style,
  textColor = 'black',
  backgroundColor,
  avatar,
  alt,
  onDelete,
}) => {
  const [id] = useState(uuidV1());

  return (
    <Chip
      className={`chip ${className}`}
      disabled={disabled}
      style={{
        color: textColor,
        background: disabled ? DISABLED_BACKGROUND : backgroundColor,
        ...style,
      }}
      size="small"
      onClick={disabled ? undefined : onClick}
      data-tip
      data-for={id}
      avatar={avatar}
      onDelete={onDelete}
      label={
        <div>
          {!!alt && (
            <DefaultTooltip title={alt} placement="top">
              <div>
                {text}
                {element}
              </div>
            </DefaultTooltip>
          )}
          {!alt && (
            <>
              {text}
              {element}
            </>
          )}
        </div>
      }
    />
  );
};

export default DefaultChip;
